<script lang="ts">
import Switch from '@/components/core/Switch.svelte'
import type { Icon } from '@/types'

import DrawerContentIcon from './DrawerContentIcon.svelte'

type Props = {
	icon: Icon
	text: string
	name: string
	value: boolean
	testId: string
	onClick: () => void
}

let { icon, text, name, value, testId, onClick }: Props = $props()

const handleClick = (e: MouseEvent) => {
	e.preventDefault()
	onClick()
}
</script>

<button class="drawer-switch" onclick={handleClick} data-testid={testId}>
	<DrawerContentIcon {icon} />
	<span class="text-sm ml-2 flex-grow">{text}</span>
	<Switch {name} {value} {testId} />
</button>

<style lang="postcss">
.drawer-switch {
	@apply p-2 text-left rounded-lg flex items-center select-none w-full transition-colors ease-in-out delay-0 duration-75;
}
.drawer-switch:hover {
	@apply bg-neutral-100;
}
</style>
